import { useEffect } from "react";

// This is really just to bypass the react-hooks/exhaustive-deps eslint-rule

export default fun => useEffect(fun, []);
